var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    stroke: "#12B2DB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12B2DB",
    d: "M32.813 43.482c-1.993-1.568-3.996-3.617-5.874-6.204-.413-.57-.817-1.161-1.21-1.774-.51-.797-1.57-1.03-2.368-.519-.797.51-1.03 1.57-.519 2.368.429.67.87 1.316 1.323 1.94 2.068 2.85 4.293 5.126 6.528 6.884 1.367 1.075 2.455 1.748 3.123 2.076.71.349 1.566.166 2.072-.441L53.031 27.24c.606-.727.508-1.808-.22-2.414-.727-.606-1.808-.508-2.414.22L34.191 44.492c-.395-.266-.858-.602-1.378-1.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.5f37c0a8e3b02d0d304420c40e79c0b2.svg";
export { ForwardRef as ReactComponent };